export const AuthMain: React.FC<React.PropsWithChildren> = props => {
  const { children } = props

  return <main className="flex w-full justify-center">{children}</main>
}
